import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}


//Récupération d'array depuis un CSV
async function getArrayCSV(file){
    try {
        if(file){
            let formData = new FormData()

            formData.append('file', file)
            return await requestApi({method: 'POST', url: '/api/getArrayCSV?nocache=' + new Date().getTime(), params: {}, form: formData, headers: {'Content-Type': 'multipart/form-data'}})
        }
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de récupérer les données`,'Récupération de tableau')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
    toasterError,
    toasterSuccess,
    getArrayCSV,
}